import { render } from "@/components/pages/diagProjectList/DiagProjectList.html?vue&type=template&id=deedce10&external"
import script from "@/components/pages/diagProjectList/DiagProjectList.js?vue&type=script&lang=js&external"
export * from "@/components/pages/diagProjectList/DiagProjectList.js?vue&type=script&lang=js&external"

import "@/components/pages/diagProjectList/DiagProjectList.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__